import { TaxSettingsForm } from '@/components/taxes/TaxSettingsForm'
import { RecordHistoryActionMenu } from '@/components/audit-log/RecordHistoryMenu'
import { AdminPageHeader } from '@/components/patterns/admin-page'
import IfGlobalOrg from '@/components/organizations/IfGlobalOrg'
import { OrganizationContextNotice } from '@/components/patterns/info-notice'
import { usePathHelper } from '@/hooks/usePathHelper'
import { useIsReadOnly } from '@/lib/casl'
import { adminTitleHead } from '@/lib/admin-route-title'
import {
  organizationTaxSettingsQueries,
  useOrganizationTaxSettings,
} from '@/lib/services/organization-tax-settings/organization-tax-settings.query'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { BadgeCent } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/settings/taxes/')({
  component: TaxSettingsPage,
  head: () => adminTitleHead('Taxes', 'Settings'),
  loader: async ({ context, params }) => {
    if (!context.ability.can('list', 'tax-settings')) throw notFound()

    const isReadOnly = !context.ability.can('edit', 'tax-settings')
    const isGlobalOrg = Number(params.orgId) === Number(import.meta.env.VITE_TUKIOS_FLOWERS_ORG_ID)

    if (isGlobalOrg) return { isReadOnly }

    await context.queryClient.ensureQueryData(
      organizationTaxSettingsQueries.detail({ organizationId: params.orgId })
    )

    return { isReadOnly }
  },
})

function OrganizationTaxSettings() {
  const { orgId } = Route.useParams()
  const { isReadOnly } = useIsReadOnly()
  const { data: settings } = useOrganizationTaxSettings({ organizationId: orgId })
  return (
    <TaxSettingsForm
      key={orgId}
      settings={settings}
      organizationId={orgId}
      isReadOnly={isReadOnly}
    />
  )
}

export function TaxSettingsPage() {
  const path = usePathHelper()

  return (
    <div className="max-w-4xl space-y-5">
      <AdminPageHeader
        icon={BadgeCent}
        title="Taxes"
        description="Choose how you collect tax on new orders."
        actions={
          <IfGlobalOrg show={false}>
            <RecordHistoryActionMenu
              link={path.taxes.link('history')}
              triggerLabel="More tax-setting actions"
            />
          </IfGlobalOrg>
        }
      />
      <IfGlobalOrg
        show={false}
        fallback={
          <OrganizationContextNotice>
            Tax settings are florist-specific. Impersonate a florist organization to review or
            change its tax settings.
          </OrganizationContextNotice>
        }
      >
        <OrganizationTaxSettings />
      </IfGlobalOrg>
    </div>
  )
}
